import { CancelToken } from 'axios';
import { awIntegrationsApi } from './Base';
import { AWOutboundOperation, AWOutboundOperationResponse } from './types';

export const AW_OUTBOUND_OPERATION_PATH = 'outbound/v1/outboundOperation:send';

export function awOutboundOperation(requestBody: AWOutboundOperation, cancelToken?: CancelToken) {
  return awIntegrationsApi.post<AWOutboundOperationResponse>(AW_OUTBOUND_OPERATION_PATH, requestBody, { cancelToken });
}
